import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Table } from 'reactstrap';
import { array, func, number, object } from 'prop-types';
import PaymentOrdersListItem from './PaymentOrdersListItem';

const propTypes = {
  payments: array.isRequired,
  onCancelPaymentClick: func.isRequired,
  tableSettings: object,
  theme: number,
};

const PaymentOrdersList = ({
  payments = [],
  tableSettings,
  theme,
  onCancelPaymentClick,
  cancelRequestStatus,
}) => (
  <div className="payments-list">
    <Table bordered responsive className="payments-table">
      <thead className={theme !== 4 ? 'thead-light' : ''}>
        {tableSettings ? <tr>
          {tableSettings.date && <th>
            <FormattedMessage id="payments.date" defaultMessage="Date" />
          </th>}
          {tableSettings.total && <th>
            <FormattedMessage id="payments.total" defaultMessage="Total" />
          </th>}
          {tableSettings.purse && <th>
            <FormattedMessage id="payments.purse" defaultMessage="Purse" />
          </th>}
          {tableSettings.status && <th>
            <FormattedMessage id="payments.status" defaultMessage="Status" />
          </th>}
          {tableSettings.icon && <th />}
        </tr>
          :
          <tr>
            <th>
              <FormattedMessage id="payments.date" defaultMessage="Date" />
            </th>
            <th>
              <FormattedMessage id="payments.total" defaultMessage="Total" />
            </th>
            <th>
              <FormattedMessage id="payments.purse" defaultMessage="Purse" />
            </th>
            <th>
              <FormattedMessage id="payments.status" defaultMessage="Status" />
            </th>
            <th />
          </tr>
        }
      </thead>
      <tbody>

        {payments.length > 0 ? payments.map(payment => (
          <PaymentOrdersListItem
                tableSettings={tableSettings}
                key={payment.id}
                onCancelPaymentClick={onCancelPaymentClick}
                cancelRequestStatus={cancelRequestStatus}
                {...payment}
              />
        )) : <tr>
            <td colSpan={5} className='text-center'>
              <div className='card-empty'>
                <FormattedMessage id="payments.no_payments" defaultMessage="No Payments" />
              </div>
            </td>
          </tr>}
      </tbody>
    </Table>
  </div>
);

PaymentOrdersList.propTypes = propTypes;

export default PaymentOrdersList;
